var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.707 5.707L18 3a12.75 12.75 0 0 0-1 1l2 2v3a1 1 0 0 0 1 1v7.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-6a1.5 1.5 0 0 0-1.5-1.5H15V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v17a1 1 0 0 0-1 1v1h13v-1a1 1 0 0 0-1-1v-9h1.5a.5.5 0 0 1 .5.5v6a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5V6.414a1 1 0 0 0-.293-.707zM13 4v6H6V4zM9.5 19.083a2.154 2.154 0 0 1-2.134-2.174 2.184 2.184 0 0 1 .227-.959L9.5 12.189l1.907 3.761a2.184 2.184 0 0 1 .227.959A2.155 2.155 0 0 1 9.5 19.083z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.a806b4b6d13e54fa2a2b2ac958e391f1.svg";
export { ForwardRef as ReactComponent };